import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Device } from '@app/models/device.interface';
import { DeviceHelperService } from '@app/services/helpers/device-helper.service';
import { Observable } from 'rxjs';
import { HeadMetaComponent } from "@app/components/head-meta/head-meta.component";
import { LoadingErrorBlockComponent } from "@app/components/loading-error-block/loading-error-block.component";
import { LetDirective } from '@ngrx/component';
import { CreatedUpdatedDisplayComponent } from "@app/components/created-updated-display/created-updated-display.component";
import { DetailDisplayComponent } from '@app/components/detail-display/detail-display.component';
import { faCheck, faPenToSquare, faXmark, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthService } from '@app/services/auth.service';
import { DetailDateDisplayComponent } from "@app/components/detail-date-display/detail-date-display.component";
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-device-detail',
    templateUrl: './detail.page.html',
    styleUrl: './detail.page.scss',
    imports: [
        HeadMetaComponent,
        LoadingErrorBlockComponent,
        LetDirective,
        CreatedUpdatedDisplayComponent,
        DetailDisplayComponent,
        FontAwesomeModule,
        RouterModule,
        DetailDateDisplayComponent,
        HelpButtonComponent
    ]
})
export class DeviceDetailPage {
  title = "Device Detail";
  id: number;
  device$: Observable<Device>;

  faCheck = faCheck;
  faXmark = faXmark;
  faPenToSquare = faPenToSquare;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private deviceHelper: DeviceHelperService,
    public auth: AuthService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.device$ = this.deviceHelper.getById(this.id);
  }
}
